var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    [
      !_vm.mostrarTextoGenerarPdfComprobante && !_vm.isCuentaBancaria
        ? _c(
            "b-row",
            [
              _c("b-col", [
                _c("div", { staticClass: "title-block" }, [
                  _c("h3", { staticClass: "title mt-4" }, [
                    _c("span", {
                      staticClass: "sparkline bar",
                      attrs: { "data-type": "bar" },
                      domProps: {
                        textContent: _vm._s(
                          _vm.$t("entity.action.mensajeComprobante")
                        ),
                      },
                    }),
                  ]),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        [
          !_vm.tieneCuenta && _vm.isCuentaBancaria
            ? _c("b-col", [
                _c("div", { staticClass: "title-block" }, [
                  _c("h3", { staticClass: "title mt-4" }, [
                    _c("span", {
                      staticClass: "sparkline bar",
                      attrs: { "data-type": "bar" },
                      domProps: {
                        textContent: _vm._s(
                          _vm.$t(
                            "Registre su cuenta CLABE en la sección de Datos Generales para poder continuar con el proceso."
                          )
                        ),
                      },
                    }),
                  ]),
                ]),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "line-break" }),
      _vm._v(" "),
      _vm.tieneCuenta && !_vm.tieneUrl && _vm.esEditable
        ? _c(
            "b-row",
            { staticClass: "mt-3" },
            [
              _c(
                "b-col",
                [
                  _c("h5", {
                    staticClass: "form-control-label",
                    attrs: { for: "cvu-title" },
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("Ingrese nuevamente su cuenta CLABE")
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("b-form-input", {
                    attrs: {
                      id: "input-cuenta",
                      type: "text",
                      inputmode: "numeric",
                      pattern: "[0-9]*",
                      maxlength: "18",
                      placeholder: _vm.$t("Ingrese su cuenta"),
                      state: _vm.cuentaIngresada ? _vm.cuentaValida : null,
                    },
                    on: {
                      input: _vm.validarCuenta,
                      keypress: _vm.soloNumeros,
                      paste: function ($event) {
                        $event.preventDefault()
                      },
                      copy: function ($event) {
                        $event.preventDefault()
                      },
                      cut: function ($event) {
                        $event.preventDefault()
                      },
                    },
                    model: {
                      value: _vm.cuentaIngresada,
                      callback: function ($$v) {
                        _vm.cuentaIngresada = $$v
                      },
                      expression: "cuentaIngresada",
                    },
                  }),
                  _vm._v(" "),
                  _vm.cuentaIngresada && !_vm.cuentaValida
                    ? _c("b-form-invalid-feedback", [
                        _vm._v(" La cuenta no coincide. "),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col"),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "line-break" }),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _vm.mostrarBotonGenerar &&
          _vm.tieneCuenta &&
          _vm.reglasValidas &&
          _vm.isCuentaBancaria &&
          _vm.cuentaValida
            ? _c(
                "b-col",
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "primary",
                        size: "md",
                        disabled: _vm.showPdf || _vm.pdfFirma,
                      },
                      on: { click: _vm.generarVisualizar },
                    },
                    [
                      _vm.showPdf
                        ? _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("global.process.load.generando"))
                            ),
                          ])
                        : _c("span", [
                            _vm._v(_vm._s(_vm.$t("entity.action.vistaPrevia"))),
                          ]),
                      _vm._v(" "),
                      _c("b-icon", {
                        staticClass: "mr-2",
                        attrs: { icon: "binoculars" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-col",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.mostrarBotonGenerar &&
                    _vm.vistaPreviaGenerada &&
                    _vm.cuentaValida,
                  expression:
                    "mostrarBotonGenerar && vistaPreviaGenerada && cuentaValida",
                },
              ],
            },
            [
              _c(
                "b-button",
                {
                  attrs: {
                    variant: "outline-primary",
                    disabled: _vm.showPdf || _vm.pdfFirma,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.establecerPasswordDocumento()
                    },
                  },
                },
                [
                  _vm.pdfFirma
                    ? _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("global.process.load.generando")) + " "
                        ),
                      ])
                    : _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("entity.action.firmarComprobante"))
                        ),
                      ]),
                  _vm._v(" "),
                  _c("b-icon", { attrs: { icon: "pen-fill" } }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.mostrarButtonVerComprobante && _vm.isCuentaBancaria
            ? _c(
                "b-col",
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "outline-secondary",
                        href: _vm.solicitud?.comprobantePdf?.uri,
                        target: "_blank",
                      },
                    },
                    [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t("entity.action.verComprobante")
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("b-icon-file-earmark-pdf-fill", {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover",
                            modifiers: { hover: true },
                          },
                        ],
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isCuentaBancaria
        ? _c(
            "b-row",
            [
              _vm.mostrarBotonGenerar
                ? _c(
                    "b-col",
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "primary",
                            size: "md",
                            disabled: _vm.showPdf || _vm.pdfFirma,
                          },
                          on: { click: _vm.generarVisualizar },
                        },
                        [
                          _vm.showPdf
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("global.process.load.generando")
                                  )
                                ),
                              ])
                            : _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("entity.action.vistaPrevia"))
                                ),
                              ]),
                          _vm._v(" "),
                          _c("b-icon", {
                            staticClass: "mr-2",
                            attrs: { icon: "binoculars" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.mostrarBotonGenerar,
                      expression: "mostrarBotonGenerar",
                    },
                  ],
                },
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "outline-primary",
                        disabled: _vm.showPdf || _vm.pdfFirma,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.establecerPasswordDocumento()
                        },
                      },
                    },
                    [
                      _vm.pdfFirma
                        ? _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("global.process.load.generando")) +
                                " "
                            ),
                          ])
                        : _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("entity.action.firmarComprobante")
                                )
                            ),
                          ]),
                      _vm._v(" "),
                      _c("b-icon", { attrs: { icon: "pen-fill" } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.mostrarButtonVerComprobante
                ? _c(
                    "b-col",
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "outline-secondary",
                            href: _vm.solicitud?.comprobantePdf?.uri,
                            target: "_blank",
                          },
                        },
                        [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("entity.action.verComprobante")
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("b-icon-file-earmark-pdf-fill", {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true },
                              },
                            ],
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-3" },
        [
          _c(
            "b-col",
            [
              _vm.mensajeEstadoActual
                ? _c(
                    "b-alert",
                    {
                      staticClass: "d-flex align-items-center",
                      attrs: { variant: _vm.mensajeEstadoVariant, show: "" },
                    },
                    [
                      _c("b-icon", {
                        staticClass: "mr-2",
                        attrs: { icon: "info-circle-fill" },
                      }),
                      _vm._v(" "),
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(_vm.mensajeEstadoActual),
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-3" },
        [
          _c(
            "b-col",
            [
              _c(
                "b-modal",
                {
                  ref: "modal",
                  attrs: {
                    title: _vm.$t("global.menu.entities.modalComprobante"),
                    "ok-title": _vm.$t("documentos.modalButtonOk"),
                    "cancel-title": _vm.$t("documentos.modalButtonCancel"),
                  },
                  on: {
                    ok: function ($event) {
                      return _vm.generar($event)
                    },
                  },
                },
                [
                  _c(
                    "form",
                    { ref: "form" },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: _vm.$t(
                              "global.menu.entities.passwordDocumento"
                            ),
                            "label-for": "name-input",
                            "invalid-feedback": _vm.$t(
                              "documentos.passwordRequerido"
                            ),
                            state: _vm.estadoPassword,
                          },
                        },
                        [
                          _c(
                            "b-input-group",
                            [
                              _c("b-form-input", {
                                attrs: {
                                  type: _vm.mostrarPassword
                                    ? "text"
                                    : "password",
                                  "aria-placeholder": _vm.$t(
                                    "documentos.passwordPlaceholder"
                                  ),
                                  required: "",
                                  state: _vm.estadoPassword,
                                },
                                model: {
                                  value: _vm.password,
                                  callback: function ($$v) {
                                    _vm.password = $$v
                                  },
                                  expression: "password",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "b-input-group-append",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover.right",
                                          value: _vm.$t(
                                            "documentos.mostrarPassword"
                                          ),
                                          expression:
                                            "$t('documentos.mostrarPassword')",
                                          modifiers: {
                                            hover: true,
                                            right: true,
                                          },
                                        },
                                      ],
                                      on: {
                                        click: function ($event) {
                                          _vm.mostrarPassword =
                                            !_vm.mostrarPassword
                                        },
                                      },
                                    },
                                    [_c("b-icon", { attrs: { icon: "eye" } })],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.errores, function (error, index) {
        return _c(
          "b-alert",
          { key: index, attrs: { show: "", variant: "danger" } },
          [_vm._v("\n    " + _vm._s(error) + "\n  ")]
        )
      }),
      _vm._v(" "),
      _c("visualizador-pdf", {
        attrs: {
          id: "visualizador-solicitud",
          contenidoBase64: _vm.contenidoBase64,
          mostrar: _vm.pdfReady,
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }